import React from 'react'
import EmbarkBanner from '../components/newpages/embark/EmbarkBanner'
import Vouchers from '../components/vouchers/Vouchers'
import { GuideTestimonials } from "../components/newpages/guide/GuideTestimonials";
const GiftVoucher = () => {
  return (
    <>
      <EmbarkBanner />
      <Vouchers/>
      <GuideTestimonials textWhite="text-white"/>
    </>
  )
}

export default GiftVoucher